import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=2b169d49&scoped=true"
import script from "./CarouselCard.vue?vue&type=script&lang=ts"
export * from "./CarouselCard.vue?vue&type=script&lang=ts"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=2b169d49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b169d49",
  null
  
)

export default component.exports